import React from 'react';
import { useNavigate, useRouterState } from '@tanstack/react-router';
import { SideNav } from '@trussworks/react-uswds';
import InternalLink from '@components/internal-link/InternalLink';
import Select from 'react-select';

import './SideNavigation.scss';
import { scrollToElement } from '@src/utils/helpers';

const createSubLinks = (items) =>
  items?.map((item) => (
    <InternalLink
      content={item?.label}
      href={item?.href}
      key={item?.label}
      onClick={() => scrollToElement(item?.id)}
      title={item?.label}
    />
  ));

const createLinks = (items, relativePathname) =>
  items?.map((item) => (
    <React.Fragment key={item?.label}>
            
      <InternalLink
        className={`sidenav_link ${relativePathname === item.href ? 'usa-current' : ''}`}
        content={item?.label}
        href={item?.href}
      />
            {item?.subSections && <SideNav items={createSubLinks(item?.subSections)} isSubnav />}
          
    </React.Fragment>
  ));

const createOptions = (items) => items?.map((item) => ({ value: item.href, label: item.label }));

const SideNavigation = ({ children, items }) => {
  const navigate = useNavigate();

  const relativePathname = useRouterState({
    select: (state) => state.location.pathname,
  });

  return (
    <div className='side-nav-container'>
      <div className='side-nav-content'>
        <div>
          <h5>Jump To</h5>
          <Select
            className='side-nav-select'
            name='jumpTo'
            placeholder='Jump To...'
            options={createOptions(items)}
            onChange={(val) => navigate({ to: val.value })}
          />
          <SideNav items={createLinks(items, relativePathname)} />
        </div>
        <div>{children}</div>      
      </div>
    </div>
  );
};

export default SideNavigation;
